<template>
  <v-app id="inspire">
    <v-navigation-drawer
      color="#29313D"
      permanent
      app
      dark
      :mini-variant.sync="!layout.showSidebar"
    >
      <div class="d-flex flex-column fill-height pb-1">
        <div class="v-navigation-drawer__title
            gray d-flex justify-space-between align-center "
             :class="{'flex-row logo':layout.showSidebar}">
          <span v-if="layout.showSidebar">
              UwinCfg
          </span>
          <v-btn small icon class="mt-1" v-if="layout.showSidebar === true"
                 @click="layout.showSidebar = false">
            <v-icon>mdi-chevron-triple-left</v-icon>
          </v-btn>
          <v-btn small icon class="mt-1" v-if="layout.showSidebar === false"
                 @click="layout.showSidebar = true">
            <v-icon>mdi-chevron-triple-right</v-icon>
          </v-btn>
        </div>
        <div class="flex-grow-1">
          <Sidebar></Sidebar>
        </div>
        <div class="d-flex flex-row">
          <v-btn small block @click.native="logout">
            <v-icon>mdi-exit-to-app</v-icon>
            <span v-if="layout.showSidebar">Выход</span>
          </v-btn>
        </div>
      </div>

    </v-navigation-drawer>
    <v-content class="fill-height content-background">
      <error-block></error-block>
      <div class="w-100 fill-height">
        <router-view v-if="currentUserData.init"></router-view>
        <v-container v-else style="height: 100%">
          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col
              class="subtitle-1 text-center"
              cols="12"
            >
              Загрузка данных пользователя
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="deep-purple accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-content>
  </v-app>
</template>

<style>
.v-navigation-drawer__title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 32px;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  background: rgba(20, 25, 31, 1);
}

.logo {
  padding: 20px 10px 20px 32px;
}

</style>

<script>
import Sidebar from './BaseLayout/Sidebar.vue';
import ErrorBlock from './BaseLayout/ErrorBlock.vue';

export default {
  name: 'BaseLayout',
  components: {
    Sidebar, ErrorBlock,
  },
  mounted() {
    this.getCurrentUser();
  },
  computed: {
    layout() {
      return this.$store.state.layout;
    },
    currentUserData() {
      return this.$store.state.account.user;
    },
  },
  methods: {
    getCurrentUser() {
      return this.$store.dispatch('account/getCurrentUser');
    },
    logout() {
      const self = this;
      const promise = this.$store.dispatch('account/removeToken');
      promise.finally(() => {
        self.$router.push({ name: 'login' });
      });
    },

  },
};
</script>

<style scoped>

</style>
